import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { BoatStopsResponseSchema } from '../models/boat'

const getBoatStops = async (boatId: number, startDate: Date, endDate: Date) => {
  const start = startDate.toISOString().split('T')[0]
  const end = endDate.toISOString().split('T')[0]

  const res = await axios.get('/api/geo/boat_stops', {
    params: {
      boat_id: boatId,
      start,
      end,
    },
  })
  return BoatStopsResponseSchema.parse(res.data)
}

export const useBoatStops = (
  boatId: number,
  startDate: Date,
  endDate: Date
) => {
  return useQuery({
    queryKey: ['boat-stops', boatId, startDate, endDate],
    queryFn: () => getBoatStops(boatId, startDate, endDate),
    enabled: !!boatId && !!startDate && !!endDate,
    staleTime: 60 * 1000, // 1 minute
  })
}
